import { View } from "react-native";
import { Avatar, useTheme, Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

export default function DisabledFulfillments() {
  const tailwind = useTailwind();
  const { colors } = useTheme();
  return (
    <View style={tailwind("items-center mt-8")}>
      <Avatar.Icon
        icon="truck-fast"
        color={colors.onSecondaryContainer}
        style={[
          tailwind("my-8"),
          { backgroundColor: colors.secondaryContainer },
        ]}
      />
      <Text
        variant="bodyLarge"
        style={[
          tailwind("text-center mb-2"),
          { color: colors.onSurfaceVariant },
        ]}
      >
        ¡Activa envíos automáticos para agilizar tus envíos!
      </Text>
      <Text variant="displaySmall" style={tailwind("items-center")}>
        🚚📦
      </Text>
    </View>
  );
}
